module.exports = require("./build/ng-infinite-scroll.js");


/*****************
 ** WEBPACK FOOTER
 ** ngInfiniteScroll (bower component)
 ** module id = 381
 ** module chunks = 1
 **/